import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { getCategoryColor } from 'entities/MonitorSales/monitorSales.categoryColors';

// Keys must match CATEGORY_COLOR_PALETTES in monitorSales.categoryColors.ts so the legend
// always reflects the same colors used to paint charts elsewhere in Monitor Sales.
const CATEGORY_LEGEND_ITEMS: { key: string; label: string }[] = [
  { key: 'bigtime', label: 'Bigtime' },
  { key: 'premium', label: 'Premium' },
  { key: 'value', label: 'Value' },
  { key: 'sides', label: 'Sides' },
  { key: 'beverage', label: 'Beverage' },
  { key: 'extras', label: 'Extras' },
  { key: 'bundles', label: 'Bundle' },
  { key: 'others', label: 'Others' },
];

export const CategoryColorLegend: FC = () => (
  <>
    {CATEGORY_LEGEND_ITEMS.map((item) => (
      <Row key={item.key} className="mb-4">
        <Col span={24} className="ff-regular fs-xxxs" style={{ color: getCategoryColor(item.key) }}>
          {item.label}
        </Col>
      </Row>
    ))}
  </>
);
